import { render } from "./shop-name-now.vue?vue&type=template&id=106b9f38"
import script from "./shop-name-now.vue?vue&type=script&lang=ts"
export * from "./shop-name-now.vue?vue&type=script&lang=ts"

import "./shop-name-now.vue?vue&type=style&index=0&id=106b9f38&lang=less"
script.render = render

export default script